// extracted by mini-css-extract-plugin
export default {"giftcards_section":"GiftCards_giftcards_section__iOVg+"};